module.exports = __webpack_public_path__ + "static/media/delishop-online-support_s2.abd83cbf.jpg";